var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7824 4.73357L10.798 0.749192C10.7487 0.699799 10.6901 0.660614 10.6256 0.633879C10.5611 0.607144 10.492 0.593384 10.4221 0.593384C10.3523 0.593384 10.2832 0.607144 10.2187 0.633879C10.1542 0.660614 10.0956 0.699799 10.0463 0.749192L1.4646 9.33087C0.907005 9.88847 0.59375 10.6447 0.59375 11.4333C0.59375 12.2219 0.907005 12.9781 1.4646 13.5357C2.0222 14.0933 2.77846 14.4066 3.56702 14.4066C4.35558 14.4066 5.11185 14.0933 5.66945 13.5357L13.0996 6.10552L14.5745 5.61411C14.6605 5.58552 14.7377 5.53542 14.7989 5.46856C14.86 5.40171 14.903 5.32032 14.9239 5.23215C14.9447 5.14398 14.9426 5.05194 14.9179 4.96479C14.8931 4.87764 14.8465 4.79827 14.7824 4.73423V4.73357ZM12.6448 5.13665C12.5665 5.16266 12.4953 5.20654 12.4369 5.26482L9.80921 7.89251C9.24675 8.08509 8.36487 8.15814 7.21472 7.56048C6.51081 7.19259 5.87464 7.02923 5.31816 6.98076L10.4221 1.87611L13.423 4.87701L12.6448 5.13665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTube);
export default __webpack_public_path__ + "static/media/TestTube.8f4df644473a4ca7ec1c1ca3df01eff1.svg";
export { ForwardRef as ReactComponent };